/* Lubrix collection filters: AJAX filtering, sorting, pagination and mobile drawer. */
(function () {
  'use strict';

  if (window.__lubrixCollectionFiltersBound) return;
  window.__lubrixCollectionFiltersBound = true;

  var MOBILE_QUERY = '(max-width: 991px)';
  var requestController = null;
  var requestSequence = 0;
  var priceTimers = new WeakMap();

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function getCollectionSection() {
    return document.querySelector('[data-lx-collection-section]');
  }

  function getFilterForm() {
    var section = getCollectionSection();
    return section ? section.querySelector('[data-lx-filter-form]') : null;
  }

  function syncHeaderHeight() {
    var header = document.querySelector('.lx-header-fixed');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--lx-header-height',
      Math.ceil(header.getBoundingClientRect().height) + 'px'
    );
  }

  function initHeaderHeight() {
    syncHeaderHeight();

    if (window.ResizeObserver) {
      var header = document.querySelector('.lx-header-fixed');
      if (header) {
        new ResizeObserver(syncHeaderHeight).observe(header);
      }
    }

    window.addEventListener('resize', syncHeaderHeight, { passive: true });
  }

  function captureState() {
    var section = getCollectionSection();
    if (!section) return {};

    var active = document.activeElement;
    var openGroups = {};

    section.querySelectorAll('[data-lx-filter-group]').forEach(function (group) {
      openGroups[group.getAttribute('data-lx-filter-group')] = group.open;
    });

    return {
      scrollY: window.scrollY,
      openGroups: openGroups,
      focusId: active && active.getAttribute ? active.getAttribute('data-lx-focus-id') : null,
      drawerOpen: document.body.classList.contains('lx-filter-drawer-open')
    };
  }

  function restoreState(state, preserveDrawer) {
    var section = getCollectionSection();
    if (!section) return;

    Object.keys(state.openGroups || {}).forEach(function (key) {
      var group = section.querySelector('[data-lx-filter-group="' + CSS.escape(key) + '"]');
      if (group) group.open = state.openGroups[key];
    });

    if (state.focusId) {
      var focusTarget = section.querySelector('[data-lx-focus-id="' + CSS.escape(state.focusId) + '"]');
      if (focusTarget) {
        window.requestAnimationFrame(function () {
          try {
            focusTarget.focus({ preventScroll: true });
          } catch (error) {
            focusTarget.focus();
          }
        });
      }
    }

    window.scrollTo(0, state.scrollY || 0);

    if (preserveDrawer && isMobile()) {
      openDrawer();
    } else {
      closeDrawer();
    }
  }

  function setLoading(isLoading) {
    var section = getCollectionSection();
    if (!section) return;
    section.classList.toggle('is-loading', isLoading);
    section.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function showError(message) {
    var section = getCollectionSection();
    if (!section) return;

    var old = section.querySelector('[data-lx-filter-error]');
    if (old) old.remove();

    var status = document.createElement('div');
    status.className = 'lx-filter-error';
    status.setAttribute('data-lx-filter-error', '');
    status.setAttribute('role', 'alert');
    status.innerHTML = '<span>' + message + '</span><button type="button" data-lx-filter-retry>Reintentar</button>';
    section.appendChild(status);
  }

  function removeError() {
    var section = getCollectionSection();
    if (!section) return;
    var old = section.querySelector('[data-lx-filter-error]');
    if (old) old.remove();
  }

  function getSectionId() {
    var section = getCollectionSection();
    return section ? section.getAttribute('data-section-id') : null;
  }

  function buildRequestUrl(targetUrl) {
    var url = new URL(targetUrl, window.location.href);
    var sectionId = getSectionId();
    url.searchParams.delete('section_id');
    if (!sectionId) throw new Error('No collection section ID.');
    url.searchParams.set('section_id', sectionId);
    return url;
  }

  async function fetchCollectionSection(targetUrl) {
    var requestUrl = buildRequestUrl(targetUrl);

    if (requestController) requestController.abort();
    requestController = new AbortController();
    var requestId = ++requestSequence;
    requestController._lxRequestId = requestId;

    var response = await fetch(requestUrl.toString(), {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html'
      },
      credentials: 'same-origin',
      signal: requestController.signal
    });

    if (!response.ok) {
      throw new Error('HTTP ' + response.status);
    }

    var html = await response.text();
    if (!html || html.indexOf('data-lx-collection-section') === -1) {
      throw new Error('La sección de colección no fue devuelta por Shopify.');
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newSection = doc.querySelector('[data-lx-collection-section]');

    if (!newSection) {
      throw new Error('No se encontró la sección de colección en la respuesta.');
    }

    return { newSection: newSection, requestId: requestId };
  }

  async function updateCollection(targetUrl, options) {
    options = options || {};
    var section = getCollectionSection();
    if (!section) return;

    var state = captureState();
    var preserveDrawer = !!options.preserveDrawer;
    var shouldPush = options.push !== false;
    var url = new URL(targetUrl, window.location.href);
    url.searchParams.delete('section_id');

    if (url.searchParams.has('page') && options.resetPage) {
      url.searchParams.delete('page');
    }

    setLoading(true);
    removeError();

    var expectedRequestId = requestSequence + 1;

    try {
      var result = await fetchCollectionSection(url.toString());
      var newSection = result.newSection;
      var currentSection = getCollectionSection();
      if (!currentSection) return;

      currentSection.replaceWith(newSection);

      if (shouldPush) {
        window.history.pushState({ lxCollection: true }, '', url.toString());
      }

      restoreState(state, preserveDrawer);
    } catch (error) {
      if (error.name !== 'AbortError') {
        showError('No pudimos actualizar el catálogo sin recargar la página.');
      }
    } finally {
      if (requestSequence === expectedRequestId) {
        setLoading(false);
      }
    }
  }

  function buildFilterUrl(form) {
    var url = new URL(form.getAttribute('action') || window.location.pathname, window.location.href);
    var data = new FormData(form);

    url.search = '';

    data.forEach(function (value, key) {
      if (typeof value === 'string' && value.trim() !== '') {
        url.searchParams.append(key, value);
      }
    });

    url.searchParams.delete('page');
    return url;
  }

  function openDrawer() {
    var section = getCollectionSection();
    if (!section || !isMobile()) return;
    document.body.classList.add('lx-filter-drawer-open');
    section.classList.add('lx-filter-drawer-visible');

    var trigger = section.querySelector('[data-lx-filter-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var panel = section.querySelector('[data-lx-filter-panel]');
    if (panel) panel.setAttribute('aria-modal', 'true');
  }

  function closeDrawer() {
    var section = getCollectionSection();
    document.body.classList.remove('lx-filter-drawer-open');
    if (!section) return;

    section.classList.remove('lx-filter-drawer-visible');

    var trigger = section.querySelector('[data-lx-filter-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    var panel = section.querySelector('[data-lx-filter-panel]');
    if (panel) panel.removeAttribute('aria-modal');
  }

  function getFocusId(element) {
    if (!element) return null;
    var id = element.getAttribute('data-lx-focus-id');
    if (id) return id;
    id = 'lx-focus-' + Math.random().toString(36).slice(2, 10);
    element.setAttribute('data-lx-focus-id', id);
    return id;
  }

  function handleFilterChange(input) {
    var form = input.closest('[data-lx-filter-form]');
    if (!form) return;

    getFocusId(input);

    if (isMobile()) return;

    updateCollection(buildFilterUrl(form).toString(), {
      resetPage: true,
      push: true,
      preserveDrawer: false
    });
  }

  function handlePriceInput(input, event) {
    var form = input.closest('[data-lx-filter-form]');
    if (!form) return;

    getFocusId(input);

    if (event && event.key === 'Enter') {
      event.preventDefault();
    }

    if (isMobile()) return;

    var timer = priceTimers.get(form);
    if (timer) clearTimeout(timer);

    priceTimers.set(form, setTimeout(function () {
      updateCollection(buildFilterUrl(form).toString(), {
        resetPage: true,
        push: true,
        preserveDrawer: false
      });
    }, event && event.key === 'Enter' ? 0 : 450));
  }

  function handleSortChange(select) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');

    updateCollection(url.toString(), {
      resetPage: true,
      push: true,
      preserveDrawer: false
    });
  }

  function initDelegatedEvents() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.matches('[data-lx-filter-input]')) {
        handleFilterChange(target);
        return;
      }

      if (target.matches('[data-lx-sort]')) {
        handleSortChange(target);
      }
    });

    document.addEventListener('keydown', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.matches('[data-lx-price-input]') && event.key === 'Enter') {
        handlePriceInput(target, event);
      }

      if (event.key === 'Escape' && document.body.classList.contains('lx-filter-drawer-open')) {
        closeDrawer();
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target.closest ? event.target.closest('[data-lx-filter-open], [data-lx-filter-close], [data-lx-filter-apply], [data-lx-filter-link], [data-lx-pagination] a, [data-lx-filter-retry]') : null;
      if (!target) return;

      var section = target.closest('[data-lx-collection-section]');
      if (!section) return;

      if (target.matches('[data-lx-filter-open]')) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (target.matches('[data-lx-filter-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (target.matches('[data-lx-filter-apply]')) {
        event.preventDefault();
        var form = section.querySelector('[data-lx-filter-form]');
        if (!form) return;
        updateCollection(buildFilterUrl(form).toString(), {
          resetPage: true,
          push: true,
          preserveDrawer: false
        });
        return;
      }

      if (target.matches('[data-lx-filter-link]')) {
        event.preventDefault();
        updateCollection(target.href, {
          resetPage: false,
          push: true,
          preserveDrawer: false
        });
        return;
      }

      if (target.matches('[data-lx-pagination] a')) {
        event.preventDefault();
        updateCollection(target.href, {
          resetPage: false,
          push: true,
          preserveDrawer: false
        });
        return;
      }

      if (target.matches('[data-lx-filter-retry]')) {
        event.preventDefault();
        updateCollection(window.location.href, {
          resetPage: false,
          push: false,
          preserveDrawer: false
        });
      }
    });

    document.addEventListener('input', function (event) {
      var target = event.target;
      if (target && target.matches('[data-lx-price-input]')) {
        handlePriceInput(target, event);
      }
    });

    window.addEventListener('popstate', function () {
      updateCollection(window.location.href, {
        resetPage: false,
        push: false,
        preserveDrawer: false
      });
    });
  }

  function init() {
    initHeaderHeight();
    initDelegatedEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
